import {combobox, Component, fieldset, Form, form, htmlfield, textarea, textfield} from "@intermesh/goui";
import {jmapds, Module, modules} from "@intermesh/groupoffice-core";
import {t} from "./Translate";

export class SystemSettings extends Component {
	private form: Form<any>;
	private module: Module;

	constructor() {
		super();

		this.cls = "fit scroll";
		this.items.add(
			this.form = form({},

				fieldset({legend: t("E-mail invitation")},

					textfield({
						name: "templateSubject",
						label: t("Subject")
					}),

					textarea({
						name: "templateBody",
						label: t("Body"),
						autoHeight: true
					}),
				),

				fieldset({legend: t("E-mail reminder")},

					textfield({
						name: "reminderSubject",
						label: t("Subject")
					}),

					textarea({
						name: "reminderBody",
						label: t("Body"),
						autoHeight: true
					}),
				),




			)
		)

		this.module = modules.get("business", "forms")!;
		this.form.value = this.module.settings!;
	}

	async onSubmit() {
		return jmapds("Module").update(this.module.id, {settings: this.form.value});
	}
}